import { PLAN_TYPES, PRICES, BILLING_INTERVALS } from 'constants/plans';

export const BILLING_FIELDS = ['line1', 'country', 'city', 'postalCode'];

export const getSlackChurnString = (cancellationInfo, fields) => {
  const {
    accountCreated,
    accountId,
    billingEmail,
    expectedChurnDate,
    companyName,
    requestDate,
    planName,
    subscriptionStart,
    userEmail,
  } = cancellationInfo;
  const {
    competitorInfo,
    leaveReason,
    qualitativeFeedback,
    replacementInfo,
    useAgainInfo,
  } = fields;

  const slackMessage = `*Churn Alert*\nAccount ID: ${accountId}\nCompany Name: ${companyName}\nBilling Contact: ${billingEmail}\nRequestor Contact: ${userEmail}\nPlan Name:${planName}\nChurn Request Date: ${requestDate}\nAppcues Account Created Date: ${accountCreated}\nSubscription Start Date: ${subscriptionStart}\nExpected Churn Date: ${expectedChurnDate}\n\n*Churn Feedback Responses*\nChurn Reason: ${leaveReason}\nChurn Reason Detail: ${qualitativeFeedback}\nAppcues Replacement: ${replacementInfo}\nCompetitor:${competitorInfo}\nWould come back to Appcues?: ${useAgainInfo}`;

  return slackMessage;
};

export const calculatePlanPrice = ({ planInterval, plan, planLimit }) => {
  const prices = PRICES[planInterval] && PRICES[planInterval][planLimit];
  const isHighVolume = planLimit === 'high-volume';
  const isEnterprise = plan.name === 'Enterprise';

  const hasPrice = !isEnterprise && !isHighVolume;

  return hasPrice
    ? plan.price || prices[plan.pricePlanId || plan.id]
    : "Let's talk";
};

export const calculatePlanPriceFromLocation = location => {
  const params = new URLSearchParams(location.search);
  const planInterval = params.get('pi');
  const planLimit = Number.parseInt(params.get('pl'), 10);

  const planType = location.pathname.split('/').pop();
  const plan = PLAN_TYPES.find(p => p.id === planType);
  const { multiplier } = BILLING_INTERVALS[planInterval];

  const rawPrice = Number.parseFloat(
    calculatePlanPrice({ planInterval, plan, planLimit }),
    10
  );
  const monthlyPrice = calculatePlanPrice({
    planInterval: 'monthly',
    plan,
    planLimit,
  });

  return {
    ...plan,
    planType,
    planLimit,
    planInterval,
    period: BILLING_INTERVALS[planInterval].displayPeriod,
    cadence: BILLING_INTERVALS[planInterval].displayName,
    rawPrice,
    price: rawPrice * multiplier,
    savings: monthlyPrice * multiplier - rawPrice * multiplier,
  };
};

export const calculatePlanPriceFromBasicInfo = ({
  planType,
  planInterval,
  planLimit,
}) => {
  const plan = PLAN_TYPES.find(p => p.id === planType);
  const { multiplier } = BILLING_INTERVALS[planInterval];

  const rawPrice = Number.parseFloat(
    calculatePlanPrice({ planInterval, plan, planLimit }),
    10
  );
  const monthlyPrice = calculatePlanPrice({
    planInterval: 'monthly',
    plan,
    planLimit,
  });

  return {
    ...plan,
    planType,
    planLimit,
    planInterval,
    period: BILLING_INTERVALS[planInterval].displayPeriod,
    cadence: BILLING_INTERVALS[planInterval].displayName,
    rawPrice,
    price: rawPrice * multiplier,
    savings: monthlyPrice * multiplier - rawPrice * multiplier,
  };
};

export const formatNumber = price => {
  if (!price) return '$ -';
  return new Intl.NumberFormat('en-US', {}).format(price);
};

export const formatCurrency = (price, forceDecimals = true) => {
  if (!price) return '$ -';
  if (price % 1 === 0 && !forceDecimals) return `$${formatNumber(price)}`;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
};

export const STRIPE_ERROR_MAP = {
  incomplete_cvc: 'Security code is required',
  incomplete_number: 'Card number is required',
  incomplete_expiry: 'Expiration date is required',
  invalid_expiry_year_past: 'Expiration year is the past',
  invalid_number: 'Card number is invalid',
};
